import React from 'react'
import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'

const SLIDES_DEFAULT = [
   'Full Stack Developer Job',
   'Data Analyst Job',
   'QA Engineer Job',
   'Software Engineer Job',
]

const SLIDES_ENGLISH_V2 = [
   'Full Stack Developer Job',
   'Software Engineer Job',
]

export default function Animate({ englishV2 = false }) {
   const slideLabels = englishV2 ? SLIDES_ENGLISH_V2 : SLIDES_DEFAULT
   const [sliderRef] = useKeenSlider(
      {
         loop: true,
         slides: {
            origin: 'center',
            perView: 1
         },
         vertical: true
      },
      [
         slider => {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
               clearTimeout(timeout)
            }
            function nextTimeout() {
               clearTimeout(timeout)
               if (mouseOver) return
               timeout = setTimeout(() => {
                  slider.next()
               }, 1000)
            }
            slider.on('created', () => {
               nextTimeout()
            })
            slider.on('dragStarted', clearNextTimeout)
            slider.on('animationEnded', nextTimeout)
            slider.on('updated', nextTimeout)
         }
      ]
   )

   return (
      <span ref={sliderRef} className='keen-slider programs_animate'>
         {slideLabels.map((label) => (
            <span key={label} className='keen-slider__slide'>
               {label}
            </span>
         ))}
      </span>
   )
}
